import React from 'react';
import closeIcon from '../images/close_query_icon.png';
import { QueryItemStyle, ListItem, CloseButton} from '../styles/query_item_styles'


const QueryItem = ({term, ndx, color, onQuerySelect, updateHoverState, disableHover, props}) => {

  var my_color = "1px 1px 4px 1px " + color;

  return(
      <QueryItemStyle  style={{boxShadow: my_color}}>
        <ListItem>
          {term}
        </ListItem>
        <CloseButton onClick = {() => onQuerySelect(term, ndx) }>
          <img src={closeIcon} alt="close" />
        </CloseButton>
      </QueryItemStyle>
  );
};

export default QueryItem;

// isHovered={style_props} onMouseEnter= {() => updateHoverState(term, hover_active)} onMouseLeave={()=> disableHover()}
